import { BaseApiService } from './BaseApiService';
import { sharedTokenRefresh } from './tokenRefresh';

export interface CalculonChatBotMessage {
    role: 'user' | 'assistant';
    content: string;
}

export interface AskCalculonChatBotRequest {
    message?: string;
    conversationHistory?: CalculonChatBotMessage[];
}

export interface AskCalculonChatBotResponse {
    message?: string;
}

export interface CalculonChatBotNotHelpfulFeedbackRequest {
    recentMessages?: CalculonChatBotMessage[];
    isHelpful?: boolean;
}

export interface CalculonChatBotNotHelpfulFeedbackResponse {
    success?: boolean;
    message?: string;
}

export class CalculonChatBotApiService extends BaseApiService {
    constructor() {
        super(sharedTokenRefresh);
    }

    async ask(request: AskCalculonChatBotRequest): Promise<AskCalculonChatBotResponse> {
        const response = await this.postJson('/v1/calculon-chatbot/ask/post', request);
        return this.handleResponse<AskCalculonChatBotResponse>(response);
    }

    async submitFeedback(
        request: CalculonChatBotNotHelpfulFeedbackRequest,
    ): Promise<CalculonChatBotNotHelpfulFeedbackResponse> {
        const response = await this.postJson('/v1/calculon-chatbot/feedback', request);
        return this.handleResponse<CalculonChatBotNotHelpfulFeedbackResponse>(response);
    }
}

export const calculonChatBotApiService = new CalculonChatBotApiService();
